import * as Types from '../Constants/AllConstants';

// Get all processing fees (paged)
export const GetAllProcessingFeesReducer = (
  state = { fees: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.PROCESSING_FEES_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.PROCESSING_FEES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        fees: action.payload.content || [],
        pages: action.payload.totalPages || 0,
        page: action.payload.number || 0,
        totalElements: action.payload.totalElements || 0,
        size: action.payload.size || 15,
      };
    case Types.PROCESSING_FEES_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.PROCESSING_FEES_LIST_RESET:
      return { fees: [], pages: 0, page: 0 };
    default:
      return state;
  }
};

// Get order processing fees
export const OrderProcessingFeesReducer = (state = { fees: [] }, action) => {
  switch (action.type) {
    case Types.ORDER_FEES_REQUEST:
      return { loading: true };
    case Types.ORDER_FEES_SUCCESS:
      return { loading: false, fees: action.payload };
    case Types.ORDER_FEES_FAIL:
      return { loading: false, error: action.payload };
    case Types.ORDER_FEES_RESET:
      return { fees: [] };
    default:
      return state;
  }
};
